// src/api/auth.ts
import api from './index'
import type { ApiResponse } from './index'

// ✅ Интерфейсы
export interface LoginRequest {
  login: string
  password: string
}

export interface LoginResponse {
  token: string
}

export interface RegistrationRequest {
  name: string
  login: string
  email: string
  password: string
}

export interface EmailConfirmRequest {
  mail: string
  code: string
}

// ✅ Методы API авторизации
export const authApi = {
  // Вход
  login(data: LoginRequest): Promise<ApiResponse<LoginResponse>> {
    return api.post<LoginResponse>('/api/auth/login', data)
  },

  // Регистрация
  registration(data: RegistrationRequest): Promise<ApiResponse> {
    return api.post('/api/auth/registration', data)
  },

  // Подтверждение email
  confirmEmail(data: EmailConfirmRequest): Promise<ApiResponse> {
    return api.post('/api/auth/confirm', data)
  },

  // Выход (локальный)
  logout(): void {
    // Очистка токена происходит в auth store
  },

  // Проверка токена
  verifyToken(): Promise<ApiResponse> {
    return api.get('/api/auth/verify')
  },

  // Восстановление пароля
  requestPasswordReset(email: string): Promise<ApiResponse> {
    return api.post('/api/auth/password-reset', { email })
  },

  // Сброс пароля
  resetPassword(token: string, password: string): Promise<ApiResponse> {
    return api.post('/api/auth/password-reset/confirm', { token, password })
  }
}

export default authApi